export enum ConnectStatus {
  NotChecked = "NOT_CHECKED",
  Checking = "CHECKING",
  NotFound = "NOT_FOUND",
  Ready = "READY",
  SigningUp = "SIGNING_UP",
  Connecting = "CONNECTING",
}
